import { useMutation, useQueryClient } from 'react-query';
import {
  createSchoolTransportationAsync,
  deleteSchoolTransportationAsync,
  getSchoolTransportationByIdAsync,
  updateSchoolTransportationAsync,
} from '../../index';
import {
  ISchoolTransportationCreateParams,
  ISchoolTransportationProps,
  ISchoolTransportationUpdateParams
} from '../../types';
import { SCHOOL_TRANSPORTATION_KEYS } from '../useQuery';

export const useCreateSchoolTransportationAsync = () => {
  const queryClient = useQueryClient();

  return useMutation<ISchoolTransportationProps, unknown, ISchoolTransportationCreateParams>(
    createSchoolTransportationAsync, 
    {
      onSuccess: () => {
        queryClient.invalidateQueries([SCHOOL_TRANSPORTATION_KEYS.ALL]);
      },
    }
  );
};

export const useGetSchoolTransportationByIdAsync = () => {
  return useMutation(getSchoolTransportationByIdAsync);
};

export const useUpdateSchoolTransportationAsync = () => {
  const queryClient = useQueryClient();

  return useMutation<ISchoolTransportationProps, unknown, ISchoolTransportationUpdateParams>(
    updateSchoolTransportationAsync, 
    {
      onSuccess: () => {
        queryClient.invalidateQueries([SCHOOL_TRANSPORTATION_KEYS.ALL]);
      },
    }
  );
};

export const useDeleteSchoolTransportationAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteSchoolTransportationAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([SCHOOL_TRANSPORTATION_KEYS.ALL]);
    },
  });
};
